import config from '@/config/ApiConfig'
export default {
    data() {
        return {
            dialogImageUrl: '',
            dialogVisible: false
        };
    },
    computed: {
        uploadBaseUrl() {
            return config.apiServer + '/common/upload'
        },
        getUrl() {
            return url => {
                return config.apiServer + '/' + url
            }
        },
        getFileList() {
            return url => {
                if (url) {
                    if (url instanceof Array) {
                        var list = []
                        url.forEach(item => {
                            var serverUrl = config.apiServer + '/' + item
                            list.push({
                                name: item,
                                url: serverUrl
                            })
                        })
                        return list
                    } else {
                        var serverUrl = config.apiServer + '/' + url
                        return [{ name: url, url: serverUrl }]
                    }
                }
                return []
            }
        }
    },
    methods: {
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
    }
}
